import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import React from "react"
import styled from "styled-components"

import {
  COMPLETED_COLOR,
  IN_PROGRESS_COLOR,
} from "../../../helpers/constants/lawColors"
import { getCurrentLessonInfo } from "../../operators/getCurrentLessonInfo"
import {
  getFriendlyStatusString,
  getHourString,
} from "../../operators/getFriendlyCourseInfo"
import { GetMyCourses_myStudentCourses } from "../../queries/types/GetMyCourses"
import DateCompleted from "./DateCompleted"

type StudentCourse = GetMyCourses_myStudentCourses

interface Props {
  studentCourse: StudentCourse
}

const TextContent = ({ studentCourse }: Props) => {
  const completed = studentCourse.status === "FINISHED"
  const { currentLesson, totalLessons } = getCurrentLessonInfo(studentCourse)

  return (
    <Wrapper>
      <Typography variant="body1" component="p" gutterBottom>
        {studentCourse.course.title}
      </Typography>
      <Typography variant="caption" gutterBottom display="block">
        <i>{`${studentCourse.tag} | ${getHourString(
          studentCourse.course.hours
        )}`}</i>
      </Typography>
      <Typography variant="caption" gutterBottom display="block">
        <i>
          {(() => {
            const legalHours = studentCourse.course.legalHours
            const nonlegalHours = studentCourse.course.nonlegalHours
            const fairhousingHours = studentCourse.course.fairhousingHours

            // Create an array to hold the relevant breakdown
            const breakdown: string[] = []
            if (legalHours > 0) breakdown.push(`${legalHours} Legal`)
            if (nonlegalHours > 0) breakdown.push(`${nonlegalHours} Elective`)
            if (fairhousingHours > 0)
              breakdown.push(`${fairhousingHours} Fair Housing`)

            // Join the breakdown with " / " and render it
            return breakdown.join(" / ")
          })()}
        </i>
      </Typography>
      <ColoredTypography
        completed={completed}
        color="primary"
        component="div"
        gutterBottom
      >
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            {getFriendlyStatusString(studentCourse.status)}{" "}
            <DateCompleted dateCompleted={studentCourse.dateCompleted} />
          </Grid>
          <Grid item>
            <ColoredTypography
              completed={completed}
              color="primary"
              variant="caption"
            >
              <b>{currentLesson}</b> of <b>{totalLessons}</b> lessons done
            </ColoredTypography>
          </Grid>
        </Grid>
      </ColoredTypography>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 100%;
`

interface ColoredTypographyProps {
  completed: boolean
}

const ColoredTypography = styled<any>(({ completed, ...rest }: any) => (
  <Typography {...rest} />
))`
  color: ${({ completed }: ColoredTypographyProps) =>
    completed ? COMPLETED_COLOR : IN_PROGRESS_COLOR};
`

export default TextContent
